import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-84">
      <div className="max-w-3xl mx-auto text-center" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-87">
            Hacemos que arrendar deje de ser un caos
          </h2>
          <p className="text-lg text-gray-600 mb-10" data-id="element-88">
            Descubre en menos de 1 minuto si realmente tienes opciones.
          </p>

          <div className="flex justify-center" data-id="element-89">
            <Link to="/score" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-3.5 rounded-full font-medium transition-all text-base" data-id="element-90">
              Ordenar mi arriendo
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}